import React, { useEffect, useState } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxWindow } from "./../../fxms/windows/FxWindows";
import { getDay, getInloInfo, getMonthBetween } from "../common/commonMethod";
import UI_3_4_Chart from "./UI_3_4_Chart";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";

/**
 * @description 설비진단 > 설비성능분석
 * @author SONJIEUN
 * @date 01/08/2025
 * @param {*}
 * @return  설비진단 > 설비성능분석
 */

export const UI_3_4 = (props) => {
  const user = FxmsData.getUser();
  const inlo = getInloInfo(FxmsData.getInlo(user.inloNo), user);

  const [fetchComplexInlo, setFetchComplexInlo] = useState([]);
  const [fetchCompanyInlo, setFetchCompanyInlo] = useState([]);
  const [fetchPlantInlo, setFetchPlantInlo] = useState([]);
  const [fetchFacList, setFetchFacList] = useState([]);
  const [facInfoModal, setFacInfoModal] = useState(false);
  const [fetchDataState, setFetchDataState] = useState([]);
  const [fetchDataGraph, setFetchDataGraph] = useState([]);
  const [selectedFacInfo, setSelectedFacInfo] = useState([]);
  const [selected, setSelected] = useState({
    complexInloName: user.ugrpNo !== 1024 ? inlo.complexInloName : "",
    facNo: "",
    today: getDay(0), //테스트데이터 '20250110' //시화도금단지-공압기#2와 인천표면처리센터-보일러#1
    startDate: getDay(0), //테스트데이터 '20250110'
    endDate: getDay(0), //테스트데이터 '20250110'
  });

  const facInfoModalClose = () => {
    setFacInfoModal(false);
  };

  useEffect(() => {
    console.log("*** UI_3_4 ***");

    if (user.ugrpNo === 1021) {
      //산단
      selectedComplex(inlo.complexInloNo);
    } else {
      //vup (107)
      getComplexInloData();
    }
  }, [inlo, user]);

  useEffect(() => {}, [fetchDataState]);

  useEffect(() => {
    if (inlo.complexInloNo && user.ugrpNo !== 1024) {
      selectedComplex(inlo.complexInloNo);
    }
  }, [selected.method, selected.engId]);

  const getComplexInloData = async () => {
    const uri = "vup/getComplexInloList";
    try {
      const res = await FxmsData.GET(uri);

      const complexlist = res.data.filter(x => (x.inloName === "시화도금단지" || x.inloName === "인천표면처리센타"));

      setFetchComplexInlo(complexlist);
      console.log("complex List >> ", complexlist);
    } catch (e) {
      console.log("getComplexInloList error ........", e);
    }
  };

  const setComplexName = (event) => {
    const { options } = event.target;
    setSelected((prev) => ({
      ...prev,
      complexInloName: options[event.target.selectedIndex].text,
    }));
  };

  const selectedComplex = async (value) => {
    console.log("선택된 산단번호 ::", value);

    if (value === "" || !value) {
      setFetchCompanyInlo([]);
      setFetchPlantInlo([]);
      setFetchFacList([]);
      setSelectedFacInfo([]);
      setSelected((prev) => ({ ...prev, facNo: "" }));
    } else {
      console.log("선택된 산단번호 ::", value);
      const uri = "vup/getCompanyInloList/" + value;

      try {
        const res = await FxmsData.GET(uri);
        const company = res.data.filter((x) => x.inloName === "조합공용");
        if (company.length !== 0) {
          setFetchCompanyInlo(company[0]);
          selectedCompany(company[0].inloNo);
          console.log("company List >>", res.data);
        } else {
          setFetchCompanyInlo([]);
          setFetchPlantInlo([]);
          setFetchFacList([]);
        }
      } catch (e) {
        console.log("getCompanyInloList error.... ", e);
      }
    }
    console.log("selected ........", selected);
  };

  const selectedCompany = async (value) => {
    setSelected((prev) => ({ ...prev, companyInloNo: value }));

    if (value === "") {
      setFetchPlantInlo([]);
      setFetchFacList([]);
      setSelected((prev) => ({ ...prev, facNo: value }));
    } else {
      const uri = "vup/getPlantInloList/" + value;
      try {
        const res = await FxmsData.GET(uri);
        setFetchPlantInlo(res.data[0]);
        selectedPlant(res.data[0].inloNo);
        console.log("plant List >>", res.data);
      } catch (e) {
        console.log("getPlantInloList error.... ", e);
      }
    }
    setFetchFacList([]);
  };

  const selectedPlant = async (value) => {
    setSelected((prev) => ({ ...prev, plantInloNo: value }));
    if (value === "") {
      setSelected((prev) => ({ ...prev, facNo: value }));
      setFetchFacList([]);
      return;
    } else {
      const uri = "vup/getFacNoList3_5/" + value;
      try {
        const res = await FxmsData.GET(uri);
        setFetchFacList(res.data);

        if (res.data.length !== 0) {
          setSelected((prev) => ({ ...prev, facNo: res.data[0].facNo }));
          setSelectedFacInfo(res.data[0]);
          getDataState(res.data[0].facNo);
        }
        console.log("fac List >> ", fetchFacList);
      } catch (e) {
        console.log("getFacNoList error ........", e);
      }
    }
  };

  const onChangeDatas = (event) => {
    const { value, name } = event.target;

    setSelected((prev) => {
      return { ...prev, [name]: value };
    });

    if (name === "facNo") {
      const fac = fetchFacList.filter((x) => x.facNo == value)[0];
      setSelectedFacInfo(fac);

      // API 호출 해당 설비 정보
      getDataState(value);
    }
  };

  const getDataState = async (value) => {
    if (value == null) return;

    const param = {
      facNo: value,
      today: selected.today.replace(/-/gi, ""),
    };

    try {
      const uri = "vup/select_3_4";
      const res = await FxmsData.GET(uri, param);
      console.log("UI_3_4 res........", res.data);

      setFetchDataState(res.data);
      submitBtnClick(value);
    } catch (e) {
      console.log("UI_3_4 fetchData error", e);
    }
  };

  const submitBtnClick = async (value) => {
    if (selected == null) return;

    if (parseInt(selected.startDate) > parseInt(selected.endDate)) {
      FxWindow.alert("조회 기간이 잘못되었습니다.", true);
      return;
    } else if (
      getMonthBetween(
        selected.startDate.replace(/-/gi, ""),
        selected.endDate.replace(/-/gi, "")
      ) >
      3 * 12
    ) {
      FxWindow.alert("최대 3년까지 조회 가능합니다.", true);
      return;
    }

    const param = {
      facNo: value,
      startDate: selected.startDate.replace(/-/gi, ""),
      endDate: selected.endDate.replace(/-/gi, ""),
    };

    try {
      const uri = "vup/select_3_4_graph";
      const res = await FxmsData.GET(uri, param);
      console.log("UI_3_4 res........", res.data);

      setFetchDataGraph(res.data);
    } catch (e) {
      console.log("UI_3_4 fetchData error", e);
    }
  };

  const getModalHtml = () => {
    return (
      <Modal open={true} onClose={facInfoModalClose}>
        <div className="vupFacilityPopup">
          <dl>
            <dt>
              설비정보
              <span class="close" onClick={facInfoModalClose}></span>
            </dt>
            <dd>
              <ul>
                <li>설비유형 : {selectedFacInfo.facType}</li>
                <li>설비번호 : {selectedFacInfo.facName}</li>
                <li>
                  설치위치 : {selected.complexInloName}{" "}
                  {selectedFacInfo.length === 0
                    ? ""
                    : selectedFacInfo.engId === "AIR"
                    ? "공용공압실"
                    : "공용보일러실"}
                </li>
                <li>모델명 : {selectedFacInfo.modelName}</li>
                <li>제조사 : {selectedFacInfo.vendrName}</li>
                <li>설치년도 :{selectedFacInfo.instYmd}</li>
                <li>타입 : {selectedFacInfo.procTypeCd}</li>
                <li>용량 : {selectedFacInfo.operCapa}HP</li>
                {/* <li>유량 : 11.84m3/min</li>
                <li>토출압 : 8.5bar</li> */}
                <li>AS업체 : {selectedFacInfo.mntnCmpyName}</li>
                <li>
                  담당자 : {selectedFacInfo.mntnCntcName}(
                  {selectedFacInfo.mntnCntcInfo})
                </li>
              </ul>
            </dd>
          </dl>
        </div>
      </Modal>
    );
  };

  const getFacilityNowHtml = () => {
    if (selectedFacInfo.length != 0 && selectedFacInfo.engId !== "AIR") {
      return (
        <>
          <div className="vupFacilityTotal">
            <div>
              <strong>운전효율</strong>
              <p>
                <input
                  type="text"
                  defaultValue="0"
                  value={fetchDataState.effEquipVal || 0}
                />{" "}
                %
              </p>
            </div>
            <div>
              <strong>부하율</strong>
              <p>
                <input
                  type="text"
                  defaultValue="0"
                  value={fetchDataState.elecLoadVal || 0}
                />{" "}
                %
              </p>
            </div>
            <div>
              <strong>CO농도</strong>
              <p>
                <input
                  type="text"
                  defaultValue="0"
                  value={fetchDataState.conCoVal || 0}
                />{" "}
                ppm
              </p>
            </div>
            <div>
              <strong>O2농도</strong>
              <p>
                <input
                  type="text"
                  defaultValue="0"
                  value={fetchDataState.conO2Val || 0}
                />{" "}
                %
              </p>
            </div>
          </div>
          <div className="FxMuiTable">
            <table>
              <tbody>
                <tr>
                  <th>LNG 투입량</th>
                  <td>{fetchDataState.lngInputVal || 0} Nm3/hr</td>
                  {/* <th>급수유량</th>
                  <td>{fetchDataState.waterFlowVal || 0} Nm3/hr</td> */}
                  <th>스팀압력</th>
                  <td>{fetchDataState.steamPressVal || 0} bar</td>
                  <th>배기가스</th>
                  <td>{fetchDataState.exGasVal || 0} Nm3/hr</td>
                </tr>
                <tr>
                  <th rowspan="2">LNG 투입온도</th>
                  <td rowspan="2">{fetchDataState.lngTempVal || 0} ℃</td>
                  {/* <th rowspan="2">급수 온도</th>
                  <td rowspan="2">{fetchDataState.waterTempVal || 0} ℃</td> */}
                  <th>스팀온도</th>
                  <td>{fetchDataState.steamTempVal || 0}℃</td>
                  <th rowspan="2">배기가스온도</th>
                  <td rowspan="2">{fetchDataState.exGasTempVal || 0} ℃</td>
                </tr>
                <tr>
                  <th>스팀 생산량</th>
                  <td>{fetchDataState.steamOutputVal || 0} kg/hr</td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      );
    }

    return (
      <>
        <div className="vupFacilityTotal">
          <div>
            <strong>총효율</strong>
            <p>
              <input
                type="text"
                defaultValue="0"
                value={fetchDataState.effEquipVal || 0}
              />{" "}
              %
            </p>
          </div>
          <div>
            <strong>원단위</strong>
            <p>
              <input
                type="text"
                defaultValue="0"
                value={fetchDataState.basicUnitVal || 0}
              />{" "}
              kWh/Nm3
            </p>
          </div>
          <div>
            <strong>전력부하</strong>
            <p>
              <input
                type="text"
                defaultValue="0"
                value={fetchDataState.elecLoadVal || 0}
              />{" "}
              kW
            </p>
          </div>
          <div>
            <strong>가동 중 최종 수집일시</strong>
            <p>
              <input
                type="text"
                style={{ width: 250 }}
                value={fetchDataState.lastRunCollectDtm || "-"}
                readOnly
              />{" "}
            </p>
          </div>
        </div>
        <div className="FxMuiTable">
          <table>
            <tbody>
              <tr>
                <th rowSpan="2">흡입공기 온도</th>
                <td rowSpan="2">{fetchDataState.tempInputVal || 0} ℃</td>
                <th>토출온도</th>
                <td>{fetchDataState.tempStepVal || 0}℃</td>
                <th rowSpan="2">압공생산량</th>
                <td rowSpan="2">{fetchDataState.airOutputVal || 0} Nm3/hr</td>
              </tr>
              <tr>
                <th>토출압력</th>
                <td>{fetchDataState.pressStepVal || 0} bar</td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="predict">
        <div className="FxCrudFilter">
          <div className="FxFilterLeft">
            <label className="FxLabelSearch"></label>
            {user.ugrpNo === 1021 || user.ugrpNo === 1024 ? (
              <select className="FxSelectSearch" value={inlo.complexInloNo}>
                <option value={inlo.complexInloNo}>
                  {" "}
                  {inlo.complexInloName}{" "}
                </option>
              </select>
            ) : (
              <select
                className="FxSelectSearch"
                onChange={(e) => {
                  selectedComplex(e.target.value);
                  setComplexName(e);
                }}
              >
                <option value="">산업단지명</option>
                {fetchComplexInlo.map((item) => (
                  <option
                    key={item.inloNo}
                    value={item.inloNo}
                    name="complexInloNo"
                  >
                    {item.inloName}
                  </option>
                ))}
              </select>
            )}
            <select className="FxSelectSearch" value={fetchCompanyInlo.inloNo}>
              {fetchCompanyInlo.length !== 0 ? (
                <option
                  key={fetchCompanyInlo.inloNo}
                  value={fetchCompanyInlo.inloNo}
                  name="companyInloNo"
                >
                  {fetchCompanyInlo.inloName}
                </option>
              ) : (
                <option value="">회사명</option>
              )}
            </select>

            <select className="FxSelectSearch" value={fetchPlantInlo.inloNo}>
              {fetchPlantInlo.length !== 0 ? (
                <option
                  key={fetchPlantInlo.inloNo}
                  value={fetchPlantInlo.inloNo}
                  name="plantInloNo"
                >
                  {fetchPlantInlo.inloName}
                </option>
              ) : (
                <option value="">사업장명</option>
              )}
            </select>
          </div>
        </div>
        <div className="FxCrudDataGrid">
          <div className="vupFacilityWrap">
            <div className="vupFacilityLeft">
              <ul>
                {fetchFacList.map((item) => (
                  <li
                    key={item.facNo}
                    className={selected.facNo == item.facNo ? "on" : ""}
                  >
                    <Button
                      name="facNo"
                      value={item.facNo}
                      onClick={onChangeDatas}
                    >
                      {item.facDescr}
                    </Button>
                  </li>
                ))}
              </ul>
            </div>
            <div className="vupFacilityRight">
              <div className="vupFacilityTitle">
                <strong>현재상태</strong>
                {selectedFacInfo.length != 0 ? (
                  <Button
                    onClick={() => {
                      setFacInfoModal(!facInfoModal);
                    }}
                  >
                    설비정보
                  </Button>
                ) : (
                  ""
                )}

                {facInfoModal === true ? getModalHtml() : null}
              </div>
              <div className="vupFacilityNow">
                {fetchDataState !== 0 ? getFacilityNowHtml() : null}
                <div className="vupFacilityTitle">
                  <b>총효율트렌드</b>
                  <div className="FxFilterRight">
                    <input
                      className="FxDate"
                      type="date"
                      name="startDate"
                      value={selected.startDate}
                      style={{ width: "160px" }}
                      onChange={onChangeDatas}
                    />
                    <label className="FxLabelSearch">~</label>
                    <input
                      className="FxDate"
                      type="date"
                      name="endDate"
                      value={selected.endDate}
                      style={{ width: "160px" }}
                      onChange={onChangeDatas}
                    />
                    <input
                      className="FxButtonSearch"
                      type="button"
                      value="조회"
                      onClick={() => submitBtnClick(selected.facNo)}
                    />
                  </div>
                </div>
                <UI_3_4_Chart
                  facType={fetchDataGraph.facType || ""}
                  data={fetchDataGraph}
                />
              </div>
            </div>
          </div>
        </div>

        <footer>
          <div>Virtual Utility Plant</div>
          <div>Copyright 2022 VUP All rights reserved</div>
        </footer>
      </div>
    </>
  );
};
